import { render, staticRenderFns } from "./ActivityStats.vue?vue&type=template&id=6d063e96&scoped=true"
import script from "./ActivityStats.vue?vue&type=script&lang=js"
export * from "./ActivityStats.vue?vue&type=script&lang=js"
import style0 from "./ActivityStats.vue?vue&type=style&index=0&id=6d063e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d063e96",
  null
  
)

export default component.exports